import React, { Component } from "react";
import "./App.css";
import { Router, Route, Redirect, Switch } from "react-router-dom";

import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { PageNotFound } from "./pages/PageNotFound";
import { Provider } from "react-redux";
import { createAppStore } from "./store";
import { history } from "./store/history";
import { ScrollToTop } from "./components/ScrollToTop";
import { loggedInOnly, loggedOutOnly } from "./components/hocs/loggedInGuards";
import { Home } from "./pages/Home";
import { Alerts } from "./components/alerts/Alerts";
import { adminOnly } from "./components/hocs/adminOnly";
import { Send } from "./pages/Send";
import { ForgottenPassword } from "./pages/ForgottenPassword";
import { Account } from "./pages/Account";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { Start } from "./pages/Start";
import { Feed } from "./pages/Feed";

class App extends Component {
    render() {
        return (
            <Provider store={createAppStore()}>
                <Router history={history}>
                    <ScrollToTop>
                        <Switch>
                            {/* core routes */}
                            <Redirect from="/index.html" to="/" />
                            <Route
                                exact
                                path="/login"
                                component={loggedOutOnly(Login)}
                            />
                            <Route
                                exact
                                path="/register"
                                component={loggedOutOnly(Register)}
                            />
                            <Route
                                exact
                                path="/forgotten-password"
                                component={loggedOutOnly(ForgottenPassword)}
                            />
                            <Route
                                exact
                                path="/account"
                                component={loggedInOnly(Account)}
                            />
                            <Route exact path="/" component={Home} />
                            <Route
                                exact
                                path="/privacy-policy"
                                component={PrivacyPolicy}
                            />
                            <Route
                                exact
                                path="/send"
                                component={adminOnly(Send)}
                            />

                            {/* App routes */}
                            <Route
                                exact
                                path="/interests"
                                component={loggedInOnly(Start)}
                            />
                            <Route
                                exact
                                path="/feed"
                                component={loggedInOnly(Feed)}
                            />

                            <Route component={PageNotFound} />
                        </Switch>
                        <Alerts />
                    </ScrollToTop>
                </Router>
            </Provider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js